"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildPartiallyUpdated = exports.isPartiallyUpdated = void 0;
var consts_1 = require("./consts");
var isPartiallyUpdated = function (entity) {
    if (entity && entity[consts_1.IS_PARTIALLY_UPDATED]) {
        return true;
    }
    return false;
};
exports.isPartiallyUpdated = isPartiallyUpdated;
var buildPartiallyUpdated = function (entity) {
    var _a;
    if (entity) {
        return __assign(__assign({}, entity), (_a = {}, _a[consts_1.IS_PARTIALLY_UPDATED] = true, _a));
    }
    return undefined;
};
exports.buildPartiallyUpdated = buildPartiallyUpdated;
//# sourceMappingURL=partial-updates.js.map